import { render, staticRenderFns } from "./Nansen.vue?vue&type=template&id=8971996e&"
import script from "./Nansen.vue?vue&type=script&lang=js&"
export * from "./Nansen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports